const FAQData = [
    {
      header: "What does your web development and design service include?",
      body: "Our web development and design services include custom website creation, responsive design for mobile and desktop, and optimization for user experience and search engines. We work closely with you to ensure the design reflects your brand and goals."
    },
    {
      header: "How can web services and automations help my business?",
      body: "Web services and automation streamline your business processes by reducing manual tasks, improving accuracy, and saving time. We can implement solutions like automated workflows, integrations between platforms, and custom software tailored to your needs."
    },
    {
      header: "What are the benefits of your e-commerce solutions?",
      body: "Our e-commerce solutions are designed to provide secure and efficient platforms for online sales. We integrate payment gateways, inventory management systems, and user-friendly interfaces to help you manage your store and deliver a seamless shopping experience."
    },
    {
      header: "Can you help with social media marketing strategies?",
      body: "Yes, we offer targeted social media marketing services to help grow your online presence. This includes creating and managing campaigns, optimizing ads, and analyzing performance to ensure maximum engagement and return on investment."
    },
    {
      header: "What makes your cloud hosting solutions reliable?",
      body: "Our cloud hosting solutions offer fast, secure, and scalable hosting for your websites or applications. We ensure maximum uptime, data security, and performance to keep your online presence running smoothly."
    },
    {
      header: "How can your business analytics and consulting services help my growth?",
      body: "Through our business analytics and consulting services, we help you analyze key data to uncover insights that drive strategic decisions. We work with you to develop tailored strategies to overcome challenges and seize growth opportunities."
    }
  ];
  
  export default FAQData;
  